<template>
  <div>
    <!-- Price Section start-->
    <section id="tech" class="price">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 text-center">
            <h2 class="title align-items-xl-center text-center">{{$t("technologic.Title")}}
            </h2>
          </div>
          <div class="col-sm-12">
            <carousel :className='"price-carousel"'
                      :loop=true
                      :margin=30
                      :items=3
                      :center=false
                      :nav=false
                      :dots=false
                      :dotsEach=false
                      :autoplay=true
                      :responsive="{0:{items:1, dots:true},600:{items:1,dots:true},768:{items:2,dots:true},992:{items:3,nav:false},1000:{items:3,nav:false}}"
            >
              <div class="price-item">
                <div class="price-block">
                  <div class="price-type">
                    <h2>{{$t("technologic.techno.1.Title")}}</h2>
                  </div>
                  <ul class="price-feature">
                    <li>C#</li>
                    <li>PHP</li>
                    <li>Dart</li>
                    <li>Javascript</li>
                  </ul>
                </div>
              </div>
              <div class="price-item">
                <div class="price-block">
                  <div class="price-type">
                    <h2>{{$t("technologic.techno.2.Title")}}</h2>
                  </div>
                  <ul class="price-feature">
                    <li>.Net Framework & Net Core (WinForms, ASP.NET, AS.NET Core, MVC, Entity Framework)</li>
                    <li>Xamarin, Flutter</li>
                    <li>Laravel</li>
                    <li>Bootstrap, Vue.js, React.js</li>
                  </ul>
                </div>
              </div>
              <div class="price-item">
                <div class="price-block">
                  <div class="price-type">
                    <h2>{{$t("technologic.techno.3.Title")}}</h2>
                  </div>
                  <ul class="price-feature">
                  <li>MS SQL</li>
                  <li>MySQL</li>
                  <li>PostgreSQL</li>
                  <li>SQLite</li>
                  <li>No SQL (MongoDB)</li>
                  </ul>
                </div>
              </div>
              <div class="price-item">
                <div class="price-block">
                  <div class="price-type">
                    <h2>{{$t("technologic.techno.4.Title")}}</h2>
                  </div>
                  <ul class="price-feature">
                    <li>RabbitMQ</li>
                    <li>ZMQ</li>
                  </ul>
                </div>
              </div>
            </carousel>
          </div>
        </div>
      </div>
    </section>
    <!-- Price Section End -->
  </div>
</template>
<script>
  export default {
    name: 'Technologic'
  }
</script>




// WEBPACK FOOTER //
// src/components/servicePage/technologic.vue